import React from 'react';
import store from '../store/Store';

import Login from '../components/login/Login'

import { Redirect, withRouter } from 'react-router-dom';

import './loginView.scss';

type loginState = {
	article: any;
	navigation: any;
	history: any;
}

type loginProps = {
	article: any;
	navigation: any;
	history: any;
}

class LoginView extends React.Component<loginState, loginProps> {

	constructor(props) {
		super(props)

		this.state = {
			article: props.article,
			navigation: props.navigation,
			history: props.history
		}
	}

	componentDidMount() {
		store.subscribe(() => {
			this.setState({
				article: store.getState().article,
				navigation: store.getState().navigation
			})
		})
	}

	componentWillUnmount() {
		store.subscribe(() => {
			this.setState({
				article: store.getState().article,
				navigation: store.getState().navigation
			})
		})
	}

	render() {
		let {
			article,
			navigation,
			history
		} = this.state
		
	  return (
	    <div 
	    	className="LoginView"
	    >
			<Login 
				history={ history }
			/>
	    </div>
	  )
	}
}

export default withRouter(LoginView)